<div class="dialog-wrapper">
  <h3 mat-dialog-title>
    @if (hasIcon() && !data.list) {
    <mat-icon class="pointer" color="primary">{{ data.icon }}</mat-icon>
    }
    @if (data.title) {
    <ng-container>{{ data.title }}</ng-container>
    }
  </h3>
  <div mat-dialog-content>
    <p class="text" [innerHtml]="data.text | nl2br"></p>
    @if (data.subtext) {
    <p class="subtext" [innerHtml]="data.subtext | nl2br"></p>
    }
    @if (data.error) {
    <br />
    <span class="text" [innerHtml]="data.error"></span>
    }
    @if (data.type === 'prompt') {
    <mat-form-field appearance="outline" class="w-100">
      <input type="text" matInput [(ngModel)]="data.value">
    </mat-form-field>
    }
    @if (data.list) {
    <mat-chip-set>
      @for (item of data.list; track $index) {
      <mat-chip>
        @if (data.icon) {
        <mat-chip-avatar>
          <i [class]="data.icon" aria-hidden="true"></i>
        </mat-chip-avatar>
        }
        {{ item }}
      </mat-chip>
      }
    </mat-chip-set>
    }
  </div>
  <div mat-dialog-actions>
    <div style="width: 100%; text-align: center">
      @if (data.type === 'prompt') {
      <button mat-raised-button (click)="onClick()">
        <mat-icon>arrow_right</mat-icon>
        <span>{{ button_save }}</span>
      </button>
      <button mat-raised-button (click)="onNoClick()">
        <mat-icon>arrow_right</mat-icon>
        <span>{{ button_cancel }}</span>
      </button>
      }
      @if (data.type === 'confirm') {
      <div class="d-flex justify-content-end">
        <button mat-raised-button class="cancelButton" (click)="onNoClick()">
          <span>{{ 'messages.label.cancel' | translate }}</span>
        </button>
        <button mat-flat-button (click)="onClick()">
          <span>{{ 'messages.label.validate' | translate }}</span>
        </button>
      </div>
      }
      @if (data.type === 'alert') {
      <br />
      <button mat-raised-button (click)="onClick()">
        <span>{{ 'messages.label.ok' | translate }}</span>
      </button>
      }
    </div>
  </div>
</div>